var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:doordash",
    clipPath: "url(#clip0_1_3405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1485 7.7083C20.6712 6.81178 19.9583 6.06247 19.0867 5.54106C18.2151 5.01965 17.2178 4.7459 16.2021 4.7493H0.535392C0.429267 4.75019 0.325757 4.78233 0.237799 4.84172C0.149841 4.90111 0.0813353 4.9851 0.0408432 5.0832C0.000351043 5.1813 -0.0103315 5.28916 0.0101305 5.39329C0.0305925 5.49743 0.0812915 5.59323 0.155892 5.66872L3.56956 9.10255C3.71882 9.2525 3.89623 9.37147 4.09161 9.45265C4.28699 9.53382 4.49649 9.57559 4.70806 9.57555H15.753C16.1308 9.57178 16.4946 9.71825 16.7644 9.98273C17.0342 10.2472 17.1879 10.608 17.1917 10.9858C17.1954 11.3636 17.049 11.7275 16.7845 11.9973C16.52 12.2671 16.1592 12.4208 15.7814 12.4245H8.16756C8.06135 12.4253 7.95772 12.4573 7.86962 12.5166C7.78153 12.5759 7.71288 12.6599 7.67228 12.758C7.63167 12.8562 7.62091 12.9641 7.64134 13.0683C7.66177 13.1725 7.71249 13.2684 7.78714 13.344L11.2017 16.7787C11.3509 16.9287 11.5283 17.0478 11.7237 17.129C11.9191 17.2101 12.1286 17.2519 12.3402 17.2517H15.7841C20.2639 17.2517 23.6528 12.4621 21.1485 7.70647",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorDash);
export default __webpack_public_path__ + "static/media/doorDash.17cab3700bbb7065bc457ba83a81020e.svg";
export { ForwardRef as ReactComponent };